export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./style.vue?vue&type=template&id=3c03bd3f"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/style.vue?vue&type=template&id=3c03bd3f
// module id = UHX8
// module chunks = 0